import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import PopupContainer from '../../../common/components/PopupContainer';

export default function MusicAlbumEditForm4DistributionPopup3({
  onClose,
  onNext,
  onBack,
} : {
  onClose: () => void,
  onBack: () => void,
  onNext: () => void,
}) {
  return (
    <PopupContainer title="音楽配信サービス" onClose={() => { onClose(); }}>
      <form className="cake_ajax_form">
        <div className="list__body album_delivery">
          <p>
            「配信する」を押すと曲の情報が世界中の各社に送信され、約50日以内にさまざまなサイトやアプリなどで視聴・購入ができるようになります。
            <br />
            <span className="red">一度「配信する」を押すと修正はできません。</span>
            <br />
            細かい点も全てチェック済みで、
            <span className="red">ミスがないと自信が持てる場合のみ「配信する」を押してください。</span>
          </p>
          <p className="top_line" />
          <ul>
            <li className="bt">
              <CustomButton type="cancel-split" onClick={() => onBack()}>戻って再確認</CustomButton>
              <CustomButton type="default-split" onClick={() => onNext()}>配信する</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </PopupContainer>
  );
}
